// extracted by mini-css-extract-plugin
export var actionText = "_mt-4";
export var container = "_mt-0";
export var leftSection = "_mt-1";
export var rightSection = "_mt-2";
export var settingsButton = "_mt-6";
export var settingsIcon = "_mt-7";
export var shortcut = "_mt-5";
export var shortcutGroup = "_mt-3";